import React from "react";
import { Form, Input, Select, Row, Col, Card, DatePicker } from "antd";

const { Option } = Select;

const Pengangkut = ({ data, setData }) => {
    const isBC27 = data.kodeDokumen === "27";

    return (
        <Form layout="vertical">
            <Row gutter={24}>
                <Col span={isBC27 ? 24 : 12}>
                    <Card title="Pengangkutan" bordered={false} className="card-custom">
                        {isBC27 ? (
                            <>
                                <Form.Item label="Jenis Sarana Pengangkut">
                                    <Input placeholder="Jenis Sarana Pengangkut" />
                                </Form.Item>
                                <Form.Item label="Nomor Sarana Pengangkut">
                                    <Input placeholder="Nomor Sarana Pengangkut" />
                                </Form.Item>
                            </>
                        ) : (
                            <>
                                <Form.Item label="Cara Pengangkutan">
                                    <Select placeholder="Pilih Cara Pengangkutan">
                                        <Option value="1">1 - Laut</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item label="Nama Sarana Angkut">
                                    <Input placeholder="Nama Sarana Angkut" />
                                </Form.Item>
                                <Form.Item label="Nomor Voy/Flight/Nopol/Lainnya">
                                    <Input placeholder="Nomor Voy/Flight/Nopol/Lainnya" />
                                </Form.Item>
                                <Form.Item label="Bendera">
                                    <Select placeholder="Pilih Bendera">
                                        <Option value="ID">ID - INDONESIA</Option>
                                    </Select>
                                </Form.Item>
                            </>
                        )}
                    </Card>
                </Col>
                {!isBC27 && (
                    <Col span={12}>
                        <Card title="Pelabuhan & Tempat Penimbunan" bordered={false} className="card-custom">
                            <Form.Item label="Perkiraan Tanggal Tiba">
                                <DatePicker style={{ width: "100%" }} />
                            </Form.Item>
                            <Form.Item label="Pelabuhan Muat">
                                <Select placeholder="Pilih Pelabuhan Muat">
                                    <Option value="IDTPP">IDTPP - TANJUNG PRIOK</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="Pelabuhan Transit">
                                <Input placeholder="Pelabuhan Transit" />
                            </Form.Item>
                            <Form.Item label="Pelabuhan Bongkar">
                                <Input placeholder="Pelabuhan Bongkar" />
                            </Form.Item>
                            <Form.Item label="Tempat Penimbunan">
                                <Select placeholder="Pilih Tempat Penimbunan">
                                    <Option value="GUDANG">GUDANG</Option>
                                </Select>
                            </Form.Item>
                        </Card>
                    </Col>
                )}
            </Row>
        </Form>
    );
};

export default Pengangkut;
